import moment from 'moment'

export const convertMinutesToHoursString = (minutes_in_cents: number) => {
  const duration = moment.duration(minutes_in_cents / 100, 'minutes')
  const hours = Math.floor(duration.asHours())
  const minutes = duration.minutes()
  if (minutes === 0) {
    return `${hours}h`
  } else {
    return `${hours}h ${minutes}min`
  }
}
